import React from "react"
import { Outlet, type RouteObject } from "react-router-dom"

import { PermissionGate } from "../../../../components/PermissionGate/PermissionGate.tsx"
import { RoutesPaths } from "../../../../constants/routes.ts"
import ProposalAddPage from "../../../Proposals/ProposalAddPage/ProposalAddPage.tsx"
import ProposalEditPage from "../../../Proposals/ProposalEditPage/ProposalEditPage.tsx"
import ProposalViewPage from "../../../Proposals/ProposalViewPage/ProposalViewPage.tsx"
import { ProposalsPage } from "../../../Proposals/ProposalsPage/ProposalsPage.tsx"
import { ProposalsLayout } from "../../../Proposals/components/ProposalsLayout.tsx"

export const proposalRoutes: RouteObject[] = [
  {
    element: (
      <PermissionGate paths={["leads.features.lead_proposal_approval"]}>
        <Outlet />
      </PermissionGate>
    ),
    children: [
      {
        path: `${RoutesPaths.proposal.add}`,
        element: <ProposalAddPage />
      },
      {
        path: `${RoutesPaths.proposal.edit(":id")}`,
        element: <ProposalEditPage />
      },
      {
        path: RoutesPaths.proposal.list,
        element: <ProposalsLayout />,
        children: [
          { index: true, element: <ProposalsPage /> },
          { path: ":id", element: <ProposalViewPage /> }
        ]
      }
    ]
  }
]
